import { IBetHistoryFilters, IClearSessionPayload, ICreateSessionPayload } from 'shared/models/Softion'

import { BaseHttpService } from '../BaseHttpService'
import { QueryTypes } from '../data'
import { SoftionConverter } from './SoftionConverter'

class SoftionApi extends BaseHttpService {
  private converter

  private baseUrlSft2

  constructor(baseUrl: string) {
    super(baseUrl)
    this.baseUrl = `${baseUrl}/api/integrations/softion`
    this.baseUrlSft2 = `${baseUrl}/api/integrations/softion/v4`
    this.converter = new SoftionConverter()
  }

  getBetHistory = (filters: IBetHistoryFilters) =>
    this.sendQuery({
      type: QueryTypes.GET,
      url: `${this.baseUrlSft2}/betshistory/`,
      data: filters,
      converterSuccess: this.converter.convertBetHistory,
    })

  getSubBet = (id: number) =>
    this.sendQuery({
      type: QueryTypes.GET,
      url: `${this.baseUrlSft2}/transactionshistory/`,
      data: { id_on_service: id },
      converterSuccess: this.converter.convertSubBet,
    })

  cancelTicket = (id: number) => this.sendQuery({ type: QueryTypes.POST, url: `${this.baseUrl}/ticket/${id}/cancel` })

  setPlayerBalance = (data: any) =>
    this.sendQuery({ type: QueryTypes.POST, url: `${this.baseUrl}/player/balance`, data: { data } })

  createSession = (payload: ICreateSessionPayload) =>
    this.sendQuery({
      type: QueryTypes.POST,
      url: `${this.baseUrlSft2}/login`,
      data: payload,
      converterSuccess: this.converter.convertSessionUrl,
    })

  clearSession = (payload: IClearSessionPayload) =>
    this.sendQuery({
      type: QueryTypes.POST,
      url: `${this.baseUrl}/v4/logout`,
      data: payload,
    })

  createSessionTest = () => this.sendQuery({ type: QueryTypes.POST, url: `${this.baseUrl}/session/create/test` })

  setTicketPlacement = (data: any) =>
    this.sendQuery({ type: QueryTypes.POST, url: `${this.baseUrl}/ticket/placement`, data })

  setTicketStatus = (data: any) => this.sendQuery({ type: QueryTypes.POST, url: `${this.baseUrl}/ticket/status`, data })
}

export default SoftionApi
